import React, { Component } from 'react';
import { ListingForm } from './Form';

export class CreateListingView extends Component {
    render() {
        return <ListingForm title={'Create Listing'} />;
    }
}



// WEBPACK FOOTER //
// ./src/Account/StratCenter/Create.js